import { render } from "./favImagesList.vue?vue&type=template&id=dc7886bc&scoped=true"
import script from "./favImagesList.vue?vue&type=script&lang=js"
export * from "./favImagesList.vue?vue&type=script&lang=js"

import "./favImagesList.vue?vue&type=style&index=0&id=dc7886bc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-dc7886bc"

export default script